<template>
  <Teleport to="body">
    <div class="howto-backdrop" @click.self="close">
      <div class="howto" role="dialog" aria-label="How to play">
        <button class="howto__close" aria-label="Close" @click="close">✕</button>

        <div class="howto__body">
          <h3>{{ slide.title }}</h3>

          <img
            v-if="slide.art"
            class="howto__card"
            :src="`art/${slide.art}`"
            :alt="slide.artAlt"
          />

          <!-- eslint-disable-next-line vue/no-v-html -- content is this file's own
               constant strings below, never user input -->
          <p v-for="(line, i) in slide.lines" :key="i" class="howto__line" v-html="line" />
        </div>

        <div class="howto__nav">
          <button class="secondary" :disabled="index === 0" @click="index -= 1">Back</button>
          <span class="howto__dots">
            <i
              v-for="(s, i) in slides"
              :key="i"
              class="howto__dot"
              :class="{ 'howto__dot--on': i === index }"
            />
          </span>
          <button v-if="index < slides.length - 1" class="primary howto__next" @click="index += 1">
            Next
          </button>
          <button v-else class="primary howto__next" @click="close">
            Got it
          </button>
        </div>
      </div>
    </div>
  </Teleport>
</template>

<script>
// The walkthrough - the house pattern (auto-opens once, behind ? after).
// Illustrated with the game's own tile art; the claims are asserted against
// the engine in howToPlay.test.js so the tutorial cannot drift.
const SLIDES = [
  {
    title: 'A very silly race',
    art: 'camel-orange.jpg',
    artAlt: 'A racing camel',
    lines: [
      'Five camels run one lap of the track — and <strong>you are not a camel</strong>. You are a bettor, and the money is made by reading the race, not running it.',
      'Camels landing on the same space <strong>stack up</strong>, and a moving camel carries everyone on its back. A camel on top counts as ahead.',
      'The richest bettor when the first camel crosses the line wins.',
    ],
  },
  {
    title: 'One action per turn',
    art: 'pyramid-tile.jpg',
    artAlt: 'A pyramid tile',
    lines: [
      '<strong>Shake the pyramid</strong>: one random die falls out (1, 2 or 3), that camel moves — and you pocket a guaranteed pound.',
      '<strong>Back a camel for the leg</strong>: take a betting tile. When all five dice are out, the leg ends: tiles on the leading camel pay 5, 3 or 2, second place pays 1, anything else costs 1.',
      'The earlier you grab a tile the more it pays — and the less you know.',
    ],
  },
  {
    title: 'Desert tiles',
    art: 'oasis.jpg',
    artAlt: 'The oasis tile',
    lines: [
      'Place (or move) your desert tile on an empty space. A camel landing on it bounces — <strong>oasis: one forward</strong>, <strong>mirage: one back and UNDER any stack there</strong> — and pays you a pound.',
      'Never on space 1, never next to another tile.',
      'Tiles come home at the end of every leg, so there is always somewhere cheeky to put one.',
    ],
  },
  {
    title: 'The big bets',
    art: 'coin-5.jpg',
    artAlt: 'A five-pound coin',
    lines: [
      'Once per camel per game, bet it to <strong>win the whole race</strong> — or to lose it. Face down, first correct bet placed pays 8, then 5, 3, 2, then 1. Wrong bets cost 1.',
      'The race ends the moment a camel crosses the line, the leg is scored one last time, and the bet piles are turned over card by card.',
      'Robots hold seats happily — they bet on real odds, and they are beatable.',
    ],
  },
];

export default {
  name: 'HowToPlay',
  emits: ['close'],
  data() {
    return { index: 0, slides: SLIDES };
  },
  computed: {
    slide() { return this.slides[this.index]; },
  },
  methods: {
    close() { this.$emit('close'); },
  },
};
</script>
